export default "__VITE_ASSET__DVtWWV9U__"